import { __awaiter, __generator, __read } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { fetchEdgeworthConfig } from '@office-start/edgeworth-config-service';
import { getRecentRequestApiOptions, prefetchEdgeworthRecentData, } from '@office-start/edgeworth-data-service';
import { fetchIdentity, getOfficeIdentity, } from '@office-start/identity-service';
export function prefetchEdgeworthData(isStandaloneCopilot) {
    return __awaiter(this, void 0, void 0, function () {
        var identityResult, identity, _a, _b, componentContext, edgeworthConfig, apiOptions;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    identityResult = getOfficeIdentity();
                    if (!identityResult) return [3 /*break*/, 1];
                    _a = identityResult;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, fetchIdentity()];
                case 2:
                    _a = _c.sent();
                    _c.label = 3;
                case 3:
                    identity = _a;
                    return [4 /*yield*/, Promise.all([
                            fetchOfficeComponentContext(),
                            fetchEdgeworthConfig(),
                        ])];
                case 4:
                    _b = __read.apply(void 0, [_c.sent(), 2]), componentContext = _b[0], edgeworthConfig = _b[1];
                    apiOptions = getRecentRequestApiOptions({
                        /* eslint-disable @typescript-eslint/no-non-null-assertion */
                        config: edgeworthConfig,
                        context: componentContext,
                        identity: identity,
                        /* eslint-enable @typescript-eslint/no-non-null-assertion */
                        currentPage: componentContext.router.getCurrentPageForLogging(),
                    });
                    if (edgeworthConfig === null || edgeworthConfig === void 0 ? void 0 : edgeworthConfig.backgroundSyncEnabled) {
                        apiOptions.enableBackgroundSync = true;
                    }
                    !isStandaloneCopilot && prefetchEdgeworthRecentData(apiOptions);
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=dataPrefetchService.js.map